<template>
    <div>
        <div class="pras_box">
            <!-- <div class="pras_left">
				<div class="pras_title">产品分类</div>
				<div v-for="(itme,i) in classifyList" :key="i"><span @click="xin.goUrl('/oneDetails?cid='+itme.id)">{{itme.title}}</span></div>
			</div> -->
            <div class="pras_right">
                <!-- <div v-loading="loading3" class="pras_img">
                    <el-carousel trigger="click" height="450px" class="banner-box" ref="carousel" :interval="5000" arrow="always">
                        <el-carousel-item v-for="(item) in dataList" :key="item.id">
                            <img @click="xin.goNew(item.url)" :src="item.images" :alt="item.title">
                        </el-carousel-item>
                    </el-carousel>
                </div> -->
                <!-- <div class="longa">
                    <div class="kuang search_long">
                        <span class="el-icon-search"></span>
                        <div class="searchInp">
                            <el-input class="nav_search" v-model="searchVal" @change="tosearch" select-when-unmatched placeholder="按货号/产品名/其他搜索"></el-input>
                        </div>
                    </div>
                    <div class="kuang btn_long" @click="xin.goUrl('/askData')">
                        <span class="el-icon-message"></span>
                        <span>操作说明集索取</span>
                    </div>
                </div> -->

                <div class="cate m12">
                    <div class="cate-t">全部分类 <span>All product classification</span></div>
                    <div class="cate-box">
                        <div class="cate-li" v-for="item in category" :key="item.id">
                            <div class="title">{{item.title}}</div>
                            <div class="text" v-for="it in item.category_id" :key="it.id" @click="xin.goUrl('/oneDetails?cid='+it.id)">{{it.title}}</div>
                        </div>
                    </div>
                </div>

                <div class="cate-t" style="margin-top:56px;">热门产品分类 <span>Hot product classification</span></div>
                <div v-loading="loading" class="product_list min_he200">
                    <div class="pro_zi" v-for="itme in topCategory" :key="itme.id" @click="xin.goUrl('/oneDetails?cid='+itme.id)">
                        <div class="pro_img">
                            <img :src="itme.images" />
                        </div>
                        <div class="pro_title_zi">
                            <div class="pro_title">{{itme.title}}</div>
                            <div class="geng">{{itme.subtitle}}</div>
                        </div>
                    </div>
                </div>

                <div class="cate-t" style="margin-top:69px;">推荐产品 <span>Recommended Product </span></div>
                <div v-loading="loading2" class="product_list min_he200">
                    <div class="pro_zi" v-for="itme in topProduct" :key="itme.id" @click="xin.goUrl('/goodsDetails?gid='+itme.id)">
                        <div class="pro_img">
                            <img :src="itme.cover_img" />
                        </div>
                        <div class="pro_title_zi">
                            <div class="pro_title">{{itme.title}}</div>
                            <div class="geng">{{itme.subtitle}}</div>
                        </div>
                    </div>
                </div>

                <div class="cate-t" style="margin-top:69px;">新闻动态 <span>News </span></div>
                <div class="jour_box">
                    <div class="jour_zi" v-for="itme in newList" :key="itme.id">
                        <div>
                            <div class="jour_item">
                                <div class="">{{itme.create_time}}</div>
                                <div @click="xin.goUrl('/jourDetails?nid='+itme.id)" class="jour_btn laing_btn">{{itme.tab}}</div>
                            </div>
                            <span @click="xin.goUrl('/jourDetails?nid='+itme.id)" class="jour_title">
                                {{itme.title}} <span class=" iconfont icon-new"></span>
                            </span>
                            <div class="jour_ceuntn">
                                {{itme.subtitle}}
                            </div>
                        </div>
                    </div>

                </div>
                <div class="chani">
                    <span @click="xin.goUrl('/journalism/news')">查看更多</span>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import {
    mapState
} from 'vuex'
export default {
    data() {
        return {
            loading: true,
            loading2: true,
            loading3: true,
            searchVal: "",//搜索
            newList: [],//新闻动态
            topProduct: [],//推荐产品
            topCategory: [],//推荐产品
            currentIndex: 0, //轮播图索引
            dataList: [], //轮播图

            category: [],  // 全部分类
        }
    },
    created() {
        this.Postbanner();
        this.Postnews();
        this.PostTopProduct();
        this.PostTopCategory();

        this.getCategory()
    },
    computed: {
        ...mapState(['classifyList'])
    },
    methods: {
        //  全部分类
        async getCategory() {
            let { data } = await this.api.getProductCategory();
            this.category = data
        },

        tosearch(e) {//搜索
            e = e.replace(/\s+/g, "")
            if (e) this.xin.goUrl('/search?val=' + e);
        },
        async Postbanner() {//获取轮播图
            this.loading3 = true;
            let { data } = await this.api.Postbanner();
            this.dataList = data;
            this.loading3 = false;
        },
        async Postnews() {//获取新闻动态
            let { data } = await this.api.Postnews();
            this.newList = data;
        },
        async PostTopProduct() {//获取推荐产品
            this.loading = true;
            let { data } = await this.api.PostTopProduct();
            this.topProduct = data;
            this.loading = false;
        },
        async PostTopCategory() {//获取产品分类
            this.loading2 = true;
            let { data } = await this.api.PostTopCategory();
            this.topCategory = data;
            this.loading2 = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.icon-new {
    color: #b03130;
    font-size: 40px;
    position: relative;
    top: 7px;
    z-index: -1;
}
.m12 {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}
.cate-t {
    height: 37px;
    display: flex;
    align-items: center;
    font-size: 26px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
    span {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #737373;
        margin-left: 10px;
    }
}
.cate {
    .cate-t {
        margin-bottom: 26px;
    }
    .cate-box {
        column-count: 3;
        column-gap: 70px;
        .cate-li {
            break-inside: avoid;
            margin-bottom: 26px;
            width: 330px;
            height: auto;
            padding: 20px 30px;
            box-sizing: border-box;
            background: #f5f5f5;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            // box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.32);
            .title {
                font-size: 26px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: left;
                color: #eaa585;
                margin-bottom: 10px;
            }
            .text {
                font-size: 20px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: left;
                line-height: 32px;
                color: #333333;
                cursor: pointer;
            }
        }
    }
}

.el-icon-search {
    float: left;
    line-height: 50px;
    margin: 0 0px 0 10px;
}
.searchInp {
    float: left;
    width: 200px;
    line-height: 50px;
    /deep/ .el-input__inner {
        border: none;
    }
}
.banner-box {
    img {
        height: 100%;
    }
}
.pras_box {
    width: 1200px;
    margin: 50px auto 0;
    display: flex;
    justify-content: space-between;

    .pras_left {
        color: #666666;
        font-size: 18px;

        div {
            line-height: 36px;
        }

        span {
            cursor: pointer;
        }

        .pras_title {
            font-size: 26px;
            font-weight: 500;
            color: #333333;
        }
    }

    .pras_right {
        width: 1200px;

        .product_title {
            margin-top: 40px;
            font-size: 30px;
            color: #333;

            .pro_pose {
                color: #8f8f8f;
                font-size: 14px;
                margin-left: 10px;
            }
        }

        .product_list {
            .pro_zi {
                width: 288px;
                box-sizing: border-box;
                .pro_img {
                    height: 205px;
                    img {
                        height: 100%;
                    }
                }
            }
            .pro_zi:nth-child(4n + 3) {
                margin-left: 16px;
                margin-right: 8px;
            }
            .pro_zi:nth-child(4n + 4) {
                margin-left: 8px;
                margin-right: 16px;
            }
        }

        /* 新闻动态 */
        .journalism_title {
            margin-top: 50px;
            color: #333;
            font-size: 24px;

            .jour_new {
                margin-left: 10px;
                font-size: 14px;
                color: #666666;
            }
        }

        .jour_box {
            margin-top: 24px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .jour_zi {
                border-bottom: solid 1px #e6e6e6;
                padding: 30px 0;
                width: 600px;
                color: #8f8f8f;
                font-size: 15px;
                display: flex;

                div {
                    line-height: 35px;
                }

                .jour_title {
                    cursor: pointer;
                    font-size: 19px;
                    color: #333333;
                }
                .jour_item {
                    display: flex;
                }
                .jour_btn {
                    margin-left: 10px;
                    display: inline-block;
                    border-radius: 0px;
                    line-height: 24px;
                    width: auto;
                    height: 24px;
                    padding: 0 5px;
                }
            }
        }

        /* 远程搜索 */
        .longa {
            margin-top: 60px;
            display: flex;
            justify-content: space-around;

            .kuang {
                width: 280px;
                height: 50px;
                border: 1px solid #a0a0a0;
                border-radius: 25px;

                input {
                    margin: 5px 5px 5px 15px;
                    border: none;
                    width: 250px;
                    height: 40px;
                    font-size: 18px;
                }
            }

            .search_long {
            }

            .btn_long {
                cursor: pointer;
                line-height: 50px;
                font-size: 18px;
                color: #333333;
                text-align: center;
            }
        }

        .pras_img {
            // width: 600px;
            margin: 0 auto;
            img {
                width: 100%;
            }
        }
    }
}
</style>
